module.exports = __webpack_public_path__ + "static/media/sf-trial-3-wrong.d0eff350.mp3";